<template>
  <v-container fluid>
    <v-layout row wrap>
      <v-btn color="primary" dark to="/Admin/Customer">New Customer</v-btn>
      <v-spacer></v-spacer>
      <v-text-field label="Filter Customers" v-model="filterCustomers"></v-text-field>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <v-list>
          <v-list-group lazy v-for="customer in filteredCustomers" :key="customer.key" v-model="customer.expanded" no-action :class="customer.expanded ? 'grey lighten-4' : ''">
            <v-list-tile slot="activator" @click="getVehicles(customer.key)">
              <v-list-tile-content>
                <v-list-tile-title>{{customer.name}}</v-list-tile-title>
              </v-list-tile-content>
            </v-list-tile>
            <v-container fluid>
              <v-layout row wrap>
                <v-flex xs12>
                  <h3 class="mb-2">Vehicles</h3>
                </v-flex>
                <v-flex xs12>
                  <v-data-table :items="vehicles" item-key="key" :headers="vehicleDataHeaders" :pagination.sync="pagination"
                    hide-actions :loading="gettingVehicles">
                    <template slot="items" slot-scope="props">
                      <tr @click="getVehiclesDevices(props)">
                        <td :style="props.item.VehicleReg ? 'font-style: normal;' : 'font-style: italic;'">{{ props.item.VehicleReg ? props.item.VehicleReg : props.item.friendlyId ? props.item.friendlyId : 'TBC'}}</td>
                        <td v-for="template in templates" :key="template.id" :class="props.item.installedDevices && props.item.installedDevices[template.id] ? 'green--text' : 'red--text'">{{props.item.installedDevices
                          && props.item.installedDevices[template.id] ? 'Yes' : 'No'}}</td>
                      </tr>
                    </template>
                    <template slot="expand" slot-scope="props">
                      <v-card dark style="left: 0; position: sticky; width: 80vw;">
                        <v-card-title>
                          <h3>Installed Devices</h3>
                        </v-card-title>
                        <v-card-text>
                          <template v-if="vehiclesDevices.length > 0">
                            <v-data-table :items="vehiclesDevices" :headers="deviceColumns">
                              <template slot="items" slot-scope="props">
                                <tr>
                                  <td>{{props.item.id}}</td>
                                  <td>{{props.item.formattedType}}</td>
                                  <td>{{props.item.IMEI}}</td>
                                  <td>{{props.item.formattedCustomer}}</td>
                                  <td>{{props.item.formattedVehicle}}</td>
                                  <td>{{props.item.formattedProduct}}</td>
                                  <td :class="props.item.SIM === null || props.item.SIM.length < 19 ? 'error' : ''">{{props.item.SIM}}</td>
                                  <td>{{props.item.stockLocation}}</td>
                                  <!-- <td><v-btn flat icon @click="editDevice(props.item)"><v-icon>edit</v-icon></v-btn></td> -->
                                </tr>
                              </template>
                            </v-data-table>
                          </template>
                          <div v-else>
                            <h3>Vehicle does not have any devices installed</h3>
                          </div>
                        </v-card-text>
                      </v-card>
                    </template>
                  </v-data-table>
                </v-flex>
              </v-layout>
            </v-container>
          </v-list-group>
        </v-list>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { fireStore } from '../firebase'
import moment from 'moment'
export default {
  data () {
    return {
      vehicles: [],
      // customers: [],
      vehiclesDevices: [],
      filterCustomers: '',
      selectedCustomer: null,
      gettingVehicles: true,
      deviceColumns: [
        {text: 'Serial Number', value: 'id'},
        {text: 'Device Type', value: 'formattedDevice'},
        {text: 'IMEI', value: 'IMEI'},
        {text: 'Customer', value: 'formattedCustomer'},
        {text: 'Veh Reg', value: 'formattedVehicle'},
        {text: 'Product', value: 'formattedProduct'},
        {text: 'Sim Number', value: 'SIM'},
        {text: 'Stock Location', value: 'stockLocation'}
        // {text: '', value: 'id', sortable: false}
      ],
      headers: [
        {
          text: 'Vehicle Reg',
          value: 'VehicleReg',
          align: 'left'
        }
      ],
      pagination: {
        sortBy: 'VehicleReg',
        rowsPerPage: -1,
        page: 1,
        descending: false
      }
    }
  },
  created () {
    this.$store.dispatch('fetchCustomers')
    this.$store.dispatch('fetchDeviceTypes')
    this.$store.dispatch('fetchProductTypes')
    // this.getCustomers()
    // this.getTemplates()
  },
  filters: {
    formatDate (val) {
      return val !== undefined && val !== null ? moment(val).format('DD/MM/YYYY') : null
    },
    deviceNameFromId (val, templates) {
      const obj = templates.find(template => { return template.id === val })
      return obj.name ? obj.name : ''
    }
  },
  computed: {
    customers () {
      return this.$store.getters.customers
    },
    templates () {
      return this.$store.getters.productTypes
    },
    deviceTypes () {
      return this.$store.getters.productTypes
    },
    vehicleDataHeaders () {
      let arr = []
      arr.push({
        text: 'Vehicle Reg.',
        value: 'VehicleReg',
        sortable: true
      })
      this.templates.forEach(template => {
        arr.push({
          text: template.name,
          value: template.id,
          sortable: true,
          width: '50px'
        })
      })
      return arr
    },
    filteredCustomers () {
      if (this.filterCustomers.length > 0) {
        let arr = this.customers.filter(customer => { return customer.name.toLowerCase().indexOf(this.filterCustomers.toLowerCase()) > -1 })
        return arr
      }
      return this.customers
    }
  },
  methods: {
    getVehiclesDevices (props) {
      this.vehiclesDevices = []
      this.devicesLoading = true
      props.expanded = !props.expanded
      fireStore.collection('Devices').where('vehicle', '==', props.item.key)
      .get()
      .then(snap => {
        snap.forEach(doc => {
          let device = doc.data()
          device.id = doc.id
          if (device.type) {
            let type = this.deviceTypes.find(c => { return c.id === device.type })
            device.formattedType = type !== undefined ? type.name : ''
          } else {
            device.formattedType = ''
          }
          if (device.customer) {
            let customer = this.customers.find(c => { return c.key === device.customer })
            device.formattedCustomer = customer !== undefined ? customer.name : ''
          } else {
            device.formattedCustomer = ''
          }
          if (device.vehicle) {
            let vehicle = this.vehicles.find(c => { return c.key === device.vehicle })
            device.formattedVehicle = vehicle !== undefined ? vehicle.VehicleReg : ''
          } else {
            device.formattedVehicle = ''
          }
          if (device.product) {
            let product = this.templates.find(c => { return c.id === device.product })
            device.formattedProduct = product !== undefined ? product.name : ''
          } else {
            device.formattedProduct = ''
          }
          this.vehiclesDevices.push(device)
        })
        this.devicesLoading = false
      })
    },
    getVehicles (customer) {
      if (customer === this.selectedCustomer) {
        return
      }
      this.selectedCustomer = customer
      this.gettingVehicles = true
      this.vehicles = []
      fireStore.collection('Vehicles').where('Customer', '==', this.selectedCustomer)
      .get()
      .then(snap => {
        snap.forEach(doc => {
          let obj = doc.data()
          obj.key = doc.id
          this.vehicles.push(obj)
        })
        this.gettingVehicles = false
      })
      .catch(() => {
        this.gettingVehicles = false
      })
    },
    zeroFill (number, width) {
      width -= number.toString().length
      if (width > 0) {
        return new Array(width + (/\./.test(number) ? 2 : 1)).join('0') + number
      }
      return number
    },
    vehicleRegFromID (id) {
      const index = this.vehicles.findIndex(vehicle => {
        return vehicle.key === id
      })
      if (index > -1) {
        return this.vehicles[index]['VehicleReg']
      } else {
        return ''
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// Customer.vue?50917180